import type { JSX, ReactNode } from 'react'

/**
 * One row of S-D3's Connections list (SHELL-55).
 *
 * `.app-conn` is already the port of the mockup's `.sc-conn` — a 2.75rem logo
 * tile, a title, a one-line status, a badge and one small action — and it was
 * being used by the SEO and Outreach screens while the panel the design drew it
 * for rendered five prose cards instead. This component is the row; the panel
 * decides what goes in it.
 *
 * **One line of status, and it is a line.** The row's whole value is that six
 * connections can be read in one downward glance, which stops being true the
 * moment one of them wraps to a paragraph. Anything longer belongs in the
 * configuration card the row points at.
 */
export function ConnRow({
  logo,
  title,
  status,
  badge,
  action,
  help,
}: {
  logo: string
  title: string
  status: ReactNode
  badge?: ReactNode
  action?: ReactNode
  /**
   * A line under the status for what the tenant has to know *before* the
   * action will work — the Google row's "which account". Rendered only when
   * given, so every other row is unchanged.
   */
  help?: ReactNode
}): JSX.Element {
  return (
    <div className="app-conn">
      <span className="app-conn__logo" aria-hidden="true">
        {logo}
      </span>
      <span className="app-conn__body">
        <strong>{title}</strong>
        <span>{status}</span>
        {help === undefined || help === null ? null : (
          <span className="app-conn__help">{help}</span>
        )}
      </span>
      {badge}
      {action}
    </div>
  )
}
